import produce from 'immer';
import {
  STATISTICS_CAR_LIST_REQUEST,
  STATISTICS_CAR_BOX_LIST_REQUEST,
  STATISTICS_ITEMS_LIST_REQUEST,
  STATISTICS_GEM_LIST_REQUEST,
  STATISTICS_USER_LIST_REQUEST,
  STATISTICS_ITEM_ITEMS_LIST_REQUEST,
  STATISTICS_NFT_CAR_LIST_REQUEST,
  STATISTICS_NFT_LEVEL_STAT_LIST_REQUEST,
  STATISTICS_NFT_BOX_LIST_REQUEST,
  STATISTICS_TOKEN_LIST_REQUEST,
  STATISTICS_SUMMARY_LIST_REQUEST,
  STATISTICS_TOKEN_EXCEL_DATA_REQUEST,
  STATISTICS_CAR_EXCEL_DATA_REQUEST,
  STATISTICS_CAR_BOX_EXCEL_DATA_REQUEST,
  STATISTICS_ITEMS_EXCEL_DATA_REQUEST,
  STATISTICS_GEM_EXCEL_DATA_REQUEST,
  STATISTICS_NFT_CAR_EXCEL_DATA_REQUEST,
  STATISTICS_NFT_BOX_EXCEL_DATA_REQUEST,
  STATISTICS_NFT_LEVEL_EXCEL_DATA_REQUEST,
  STATISTICS_NFT_STAT_EXCEL_DATA_REQUEST, STATISTICS_ITEM_ITEMS_EXCEL_DATA_REQUEST,
} from '../../constants/monitoring/statisticsConstants';

const initialState = {

};

const statisticsReducer = (state = initialState, action = {}) => produce(state, draft => {
  switch (action.type) {
    // 요약
    case STATISTICS_SUMMARY_LIST_REQUEST:
      break;
    // 재무

    // 토큰
    case STATISTICS_TOKEN_LIST_REQUEST:
      break;
    case STATISTICS_TOKEN_EXCEL_DATA_REQUEST:
      break;

    // 마켓
    case STATISTICS_CAR_LIST_REQUEST:
      break;
    case STATISTICS_CAR_EXCEL_DATA_REQUEST:
      break;
    case STATISTICS_CAR_BOX_LIST_REQUEST:
      break;
    case STATISTICS_CAR_BOX_EXCEL_DATA_REQUEST:
      break;
    case STATISTICS_ITEMS_LIST_REQUEST:
      break;
    case STATISTICS_ITEMS_EXCEL_DATA_REQUEST:
      break;
    case STATISTICS_GEM_LIST_REQUEST:
      break;
    case STATISTICS_GEM_EXCEL_DATA_REQUEST:
      break;

    // NFT
    case STATISTICS_NFT_CAR_LIST_REQUEST:
      break;
    case STATISTICS_NFT_CAR_EXCEL_DATA_REQUEST:
      break;
    case STATISTICS_NFT_LEVEL_STAT_LIST_REQUEST:
      break;
    case STATISTICS_NFT_LEVEL_EXCEL_DATA_REQUEST:
      break;
    case STATISTICS_NFT_STAT_EXCEL_DATA_REQUEST:
      break;
    case STATISTICS_NFT_BOX_LIST_REQUEST:
      break;
    case STATISTICS_NFT_BOX_EXCEL_DATA_REQUEST:
      break;

    // 아이템
    case STATISTICS_ITEM_ITEMS_LIST_REQUEST:
      break;
    case STATISTICS_ITEM_ITEMS_EXCEL_DATA_REQUEST:
      break;
    // 유저
    case STATISTICS_USER_LIST_REQUEST:
      break;

    default:
      break;
  }
});

export default statisticsReducer;
